<template>
  <v-container>
    <template>
      <v-card>
        <v-card-title>
          Vessel
          <v-spacer></v-spacer>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field> -->
        </v-card-title>
        <v-data-table
          :headers="vesselHeaders"
          :items="vessels"
          :loading="loading.vessel"
          :items-per-page="5"
          class="elevation-1"
          dense
        >
          <template v-slot:item.tgl_berangkat="{ item }">
            <div>
              {{ formatDate(item.tgl_berangkat) }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              class="mr-2"
              @click="
                state.editVessel = true;
                state.nowKV = item.kv;
                state.dataVessel = item;
              "
            >
              mdi-pencil
            </v-icon>
            <div class="d-md-none my-5"></div>
            <!-- <v-icon class="mr-2" @click="deleteVessel(item.id)">
              mdi-delete
            </v-icon> -->
            <div class="d-md-none my-5"></div>
            <v-icon
              @click="
                state.openListBL = true;
                state.nowKV = item.kv;
              "
            >
              mdi-playlist-edit
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- List BL Modal -->
    <ListBL
      :openModal="state.openListBL"
      :kv="state.nowKV"
      @close-modal="
        state.openListBL = false;
        state.nowKV = '';
      "
    />

    <!-- List BL Modal -->
    <EditVessel
      :openModal="state.editVessel"
      :kv="state.nowKV"
      :data="state.dataVessel"
      @close-modal="
        state.editVessel = false;
        state.nowKV = '';
      "
    />
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DataVesselView",
  components: {
    ListBL: () => import("@/components/DataBL/ListBL.vue"),
    EditVessel: () => import("@/components/Vessel/EditVessel.vue")
  },
  data() {
    return {
      search: "",
      loading: {
        container: false,
        vessel: false
      },
      state: {
        openListBL: false,
        editVessel: false,
        nowKV: "",
        dataVessel: {}
      },
      vesselHeaders: [
        { text: "Tgl Berangkat", value: "tgl_berangkat" },
        { text: "KV", value: "kv" },
        { text: "Vessel", value: "vessel" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      vessels: []
    };
  },
  methods: {
    async fetchVessel() {
      this.loading.vessel = true;

      await axios
        .get(`vessel`)
        .then(res => {
          this.vessels = res.data;

          this.loading.vessel = false;
        })
        .catch(err => {
          this.loading.vessel = false;

          alert(err.response.data.message);
        });
    },
    async deleteVessel(id) {
      await axios
        .delete(`vessel/${id}`)
        .then(res => {
          this.fetchVessel();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    focusRefs(id) {
      this.$refs[id].focus();
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  },
  created() {
    this.fetchVessel();
  }
};
</script>

<style scoped>
input {
  width: 100%;
  background-color: white;
  padding: 0 5px;
}
</style>
